import { Map, List } from 'immutable'
import { get, isValid } from './index'

export const SET_FILTER_SET_DATA = 'SET_FILTER_SET_DATA'
export const SET_FILTER_SET_PROCESSING = 'SET_FILTER_SET_PROCESSING'
export const SET_FILTER_SET_EXPANDED = 'SET_FILTER_SET_EXPANDED'
export const SET_FILTER_SET_VISIBLE = 'SET_FILTER_SET_VISIBLE'
export const RESET_FILTER_SET_DATA = 'RESET_FILTER_SET_DATA'

export function getFilterSetData (options = {}) {
  const { filterSet } = options

  return async function getFilterDataThunk (dispatch, getState) {
    const { filterSetState = Map(), user = Map() } = getState()
    const userLanguage = user.getIn(['data', 'language'], List())
    const language = userLanguage.size > 0 ? userLanguage.toJS() : undefined
    // const filterSet.getIn([filterSet.filterSet, 'data'], List())
    if (!isValid(filterSet)) {
      dispatch(setFilterSetData(filterSet, Map()))
      return
    }
    if (filterSetState.getIn([filterSet, 'processing'])) {
      return
    }
    dispatch(setFilterSetProcessing(filterSet, true))
    const result = await get({ filterSet, language })
    dispatch(setFilterSetData(filterSet, result.get('data')))
  }
}

export function setFilterSetData (filterSet, data, processing = false) {
  return {
    type: SET_FILTER_SET_DATA,
    payload: { filterSet, data, processing },
  }
}

export function resetFilterSetData () {
  return {
    type: RESET_FILTER_SET_DATA,
    payload: {},
  }
}

export function setFilterSetProcessing (filterSet, value) {
  return {
    type: SET_FILTER_SET_PROCESSING,
    payload: { filterSet, value },
  }
}

export function setFilterSetExpanded (value) {
  return {
    type: SET_FILTER_SET_EXPANDED,
    payload: value,
  }
}

export function setFilterSetVisible (value) {
  return {
    type: SET_FILTER_SET_VISIBLE,
    payload: value,
  }
}
